import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/guidelines")({
  component: Guidelines
});

function Guidelines() {
  return (
    <div className="from-background-gradient via-background to-background text-tx-primary scroll-primary flex h-screen w-screen flex-col overflow-auto bg-gradient-to-b p-8 antialiased">
      <h1 className="text-tx-primary mb-4 text-3xl font-bold">Community Guidelines</h1>

      <section className="mb-8">
        <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">Age-Restricted Content</h2>
        <p className="mb-4">Strictly prohibited content involving:</p>
        <ul className="mb-6 list-inside list-disc">
          <li>Underage characters (under 18)</li>
          <li>Characters with child-like appearances</li>
          <li>Characters with child-like mental states</li>
          <li>School-age implications (i.e the character is in high school)</li>
          <li>Media exclusively targeted at very young children</li>
          <li>Characters where the user is under aged</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">Family-Related Content</h2>
        <ul className="mb-4 list-inside list-disc">
          <li>Incestuous scenarios or implications</li>
          <li>NSFW family roleplay</li>
        </ul>
        <p className="mb-2 font-semibold">Exceptions:</p>
        <ul className="mb-6 list-inside list-disc">
          <li>Non blood relations i.e step-family, in-laws</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">Animal-Related Content</h2>
        <ul className="mb-4 list-inside list-disc">
          <li>Bestiality</li>
          <li>Non-anthropomorphic animal content</li>
        </ul>
        <p className="mb-2 font-semibold">Exceptions:</p>
        <ul className="mb-6 list-inside list-disc">
          <li>Characters passing the Harkness test</li>
          <li>Stylized anthropomorphic characters (furries)</li>
          <li>Non-realistic anthropomorphic depictions</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">Necrophilia</h2>
        <ul className="mb-6 list-inside list-disc">
          <li>Characters with necrophilic themes are not allowed</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">Disturbing Content</h2>
        <ul className="mb-6 list-inside list-disc">
          <li>Disturbing content (that does not violate any guidelines) must be clearly labeled</li>
          <li>Extreme fetish content requires appropriate warning tags</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">Fictional Non Consensual Setting</h2>
        <p>Fictional scenarios of a non consensual themes are permitted</p>
        <p className="mb-4">Provided that they meet these strict conditions:</p>
        <ul className="mb-6 list-inside list-disc">
          <li>Must include "Dead Dove" tag</li>
          <li>Clear content warnings in description</li>
          <li>
            Users can stop, redirect, or modify any roleplay content at any time. Participation in non-consensual
            scenarios implies acceptance of the content, and neither moderators nor character creators can be held
            responsible.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">Enforcement</h2>
        <ul className="mb-6 list-inside list-disc">
          <li>Violations may result in content removal</li>
          <li>Repeated violations may lead to account suspension</li>
        </ul>
      </section>
    </div>
  );
}
